import { CreateGameScreen } from '@/screens/index'

export default function () {
  return <CreateGameScreen />
}
